export default "__VITE_ASSET__Dmjh$31x__"